import React, { useEffect } from 'react'
import { PricingContainer } from './Pricing.styled'
import Section from 'components/Section/Section'
import Container from 'components/Container/Container'
import PricingList from 'components/PricingList'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

function PricingPage() {
  const { logEvent } = useAmplitude()

  useEffect(() => {
    logEvent(AMPLITUDE_EVENTS.PRICING_PAGE_EVENT)
  }, [])

  return (
    <PricingContainer>
      <Section backgroundColor="backgroundSecundary">
        <Container size="medium">
          <PricingList />
        </Container>
      </Section>
    </PricingContainer>
  )
}

export default PricingPage
